import { isNil } from 'lodash';
import { useCallback } from 'react';

import { PatientSimple, PatientSimpleQuery } from '@dreryk/egabinet-patient-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { Direction, paginations } from '@dreryk/command-query-ws-client';
import { Slot } from '@dreryk/watermelon';

const pagination = paginations
   .all<PatientSimple>()
   .orderedBy('lastName', Direction.ASCENDING)
   .orderedBy('firstName', Direction.ASCENDING)
   .orderedBy('externalIdentifier', Direction.ASCENDING);

export const createPatientSearchCreator = (excludedPatientId?: number) => {
   return (searchText: string | null): (() => CqrsQueryPerformResult<PatientSimple[]>) => {
      return useCallback(async () => {
         const patients = await performCqrsQuerySearch<PatientSimple>(() => {
            const patientSimpleQuery = new PatientSimpleQuery();
            patientSimpleQuery.excludedId = excludedPatientId ? Slot.of(excludedPatientId) : undefined;
            patientSimpleQuery.freeformCriteria = Slot.emptyIfNull(searchText);
            patientSimpleQuery.externalIdentifierTypes = Slot.of(['PESEL', 'PASSPORT']);
            return patientSimpleQuery;
         }, pagination);
         return patients.filter((patient) => !isNil(patient.firstName) && !isNil(patient.lastName));
      }, [searchText]);
   };
};
